import { createReducer } from '@reduxjs/toolkit';
import { LoadingStatuses } from 'core/common/entities';
import {
  scanProcessingFailed,
  scanProcessingIdle,
  scanProcessingStarted,
  scanProcessingSucceed,
} from './actions';
import { scanInitialState } from './state';

export const scanReducer = createReducer(scanInitialState, (builder) => {
  builder
    .addCase(scanProcessingIdle, (state) => {
      state.processingStatus = LoadingStatuses.IDLE;
    })
    .addCase(scanProcessingStarted, (state) => {
      state.processingStatus = LoadingStatuses.PENDING;
    })
    .addCase(scanProcessingSucceed, (state) => {
      state.processingStatus = LoadingStatuses.FULFILLED;
    })
    .addCase(scanProcessingFailed, (state) => {
      state.processingStatus = LoadingStatuses.FAILED;
    });
});
